<!-- eslint-disable vue/no-v-html -->
<script lang="ts" setup>
import type { SectionsRichTextCkeditor } from '@autobid/strapi-integration/rest/components'
import { useCkeditor } from '@autobid/ui/composables/useCkeditor'
import { richTextCkeditorCva } from '@autobid/ui/utils/cva/richTextCkeditorCva'

interface Props {
  data: SectionsRichTextCkeditor
  /**
   * set true if you want to delcare your own, custom prose style declaration
   */
  noProse?: boolean
}

defineProps<Props>()

const { formatContent } = useCkeditor()
</script>

<template>
  <div
    :id="data.anchor"
    class="rich-cke max-w-full px-3 xl:pl-0"
    :style="{
      backgroundColor: data.backgroundColor || undefined,
    }"
    :class="[
      richTextCkeditorCva({ width: data.width, alignedContent: data.alignedContent?.name }),
      !noProse && 'prose',
    ]"
    v-html="formatContent(data.content || '')"
  />
</template>

<style lang="scss">
@use './style.scss';
</style>
